export enum ProjectReportType {
  ASBESTOS = 1,
  MEASUREMENT = 2,
  NEGATIVE_PRESSURE = 3
}

export default { ProjectReportType };